import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { DoctorProfile } from '@/types'
import HeaderComponent from '../Header/HeaderComponent.vue'
import router from '@/router'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useUserActions } from '@/stores/user-actions'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentComment',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const id = ref()
const userAction = useUserActions()
const isLoading = ref(true)
const doctor = ref<DoctorProfile | undefined>(undefined)
const rating = ref(3)
const ratingLeon = ref(5)
onMounted(() => {
  id.value = route.params.id
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mr-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "custom-title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('doctor.student-comment')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, {
            text: _ctx.$t('be-first')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('no-comments')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})